import React, { useState, useEffect, useCallback } from "react";

import { useTranslation } from "react-i18next";

import useAuth from "../../../../hooks/useAuth";

import {
	Grid,
	CircularProgress,
	Button,
	Autocomplete,
	FormControlLabel,
	Checkbox,
	FormGroup,
} from "@mui/material";
import useMutationAuth from "../../../../hooks/useMutationAuth";
import { LOGOUT_USER } from "../../../../graphql/user";

import IALoadingButton from "../../../../components/IAButtons/IALoadingButton";
import ContainerCard from "../../../../components/Cards/ContainerCard";
import TaskTabsModal from "../../../../components/Modal/TaskTabsModal";
import RoundedDatePicker from "../../../../components/DateField/RoundedDatePicker";
import AutoComplete from "../../../../components/AutoComplete";
import axios from "axios";
import { EXPORT_TO_EXCEL } from "../../../../graphql/reports";
import { GET_TASKS_BY_PROJECT_DROPDOWN } from "../../../../graphql/task";
import { GET_ALL_PROJECTS_DROPDOWN } from "../../../../graphql/project";
import { GET_ALL_EMPLOYEES_DROPDOWN } from "../../../../graphql/employee";

import useQueryAuth from "../../../../hooks/useQueryAuth";
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import { GET_TIME_ENTRIES } from "../../../../graphql/timeEntry";
import urls from "../../../../urls";

import { useSnackbar } from "notistack";

import { getTable } from "./_table";

import colors from "../../../../assets/theme/light/colors";

import DataTable from "../../../../components/Tables/DataTable";
import { exportToExcel } from "../../../../utils/exportToExcel";
import { handleValidateDates } from "../../../../utils/functions";
import FieldModal from "../../../../components/Modal/FieldModal";
import PaperComponent from "../../../../components/Modal/PaperComponent";
import { day_month_year } from "../../../../utils/timezones";
import RoundedTextField from "../../../../components/TextFields/RoundedTextField";
import AutoCompletePaper from "../../../../components/Paper/AutoCompletePaper";
import Tooltip from "../../../../components/Tooltip";
import CustomButton from "../../../../components/CustomButton";
import { NextIcon, PreviousIcon } from "../../../../components/Icon";
import {
	DATE_FILTER_DATA,
	handleDateBackward,
	handleDateForward,
	handleTimeBetween,
} from "../../../../utils/period";
import * as FileSaver from "file-saver";
import DateTime from "../../../../components/DateTime";
import EditRecord from "../../Timesheets/Timesheets-Form/components/EditRecord";
import TimeEntryDrawer from "../../Timesheets/Timesheets-Form/components/TimeEntryDrawer";

import { v4 as uuidv4 } from "uuid";
import {
	GET_ALL_CUSTOMERS_DROPDOWN,
	GET_ALL_PROJECT_DIMENSIONS,
} from "../../../../graphql/customer";

function ExcelReport() {
	const {
		storeUserTenant,
		storeUserGuid,
		userRoles,
		jwtToken,
		logout,
		updateToken,
		projectDimension1Label,
		projectDimension2Label,
	} = useAuth();
	const backendURL = process.env.REACT_APP_REST_URL;
	const { dark_logo_blue } = colors;

	const { t } = useTranslation();

	const data_filter = DATE_FILTER_DATA(t);

	const userTimezone = Intl.DateTimeFormat()
		.resolvedOptions()
		.timeZone.split("/")[0];

	const { enqueueSnackbar } = useSnackbar();

	const { manageTimeEntry } = userRoles;

	const [re, setRe] = useState(false);
	const [openDialog, setOpenDialog] = useState(false);

	const [includeSubtasks, setIncludeSubtasks] = useState(false);

	const nowDate = new Date();

	const firstDayOfWeek = new Date(nowDate);
	firstDayOfWeek.setDate(
		nowDate.getDate() - nowDate.getDay() + (nowDate.getDay() === 0 ? -6 : 1)
	);
	const [exportOptions, setExportOptions] = useState([
		{
			id: 1,
			title: t("reports.ByTaskByTimeEntry.label"),
		},
		{
			id: 2,
			title: t("reports.ByTask.label"),
		},
		{
			id: 3,
			title: t("reports.ByTaskByTimeEntryByResource.label"),
		},
	]);
	const [exportOption, setExportOption] = useState({
		id: 1,
		title: t("reports.ByTaskByTimeEntry.label"),
	});
	const [includeOptions, setIncludeOptions] = useState([
		{
			id: 1,
			title: t("reports.BillableAndNonBillable.label"),
		},
		{
			id: 2,
			title: t("reports.onlyBillable.label"),
		},
		{
			id: 3,
			title: t("reports.onlyNonBillable.label"),
		},
	]);
	const [includeOption, setIncludeOption] = useState({
		id: 1,
		title: t("reports.BillableAndNonBillable.label"),
	});

	const lastDayOfWeek = new Date(firstDayOfWeek);
	lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

	const [dateTo, setDateTo] = useState(lastDayOfWeek);

	const [dateFrom, setDateFrom] = useState(firstDayOfWeek);

	const [dateVal, setDateVal] = useState(
		data_filter.find((x) => x.mnemonic === "week")
	);

	const [open, setOpen] = useState(false);
	const [columns, setColumns] = useState([]);

	const [projectsValue, setProjectsValue] = useState([]);

	const [taskIDs, setTaskIDs] = useState([]);
	const [taskValue, setTaskValue] = useState([]);
	const [projectsList, setProjectsList] = React.useState([]);

	const [timer, setTimer] = useState(null);
	const [data, setData] = useState([]);
	const [numOfRecords, setNumOfRecords] = useState(0);

	const [fetchTasks, setFetchTasks] = useState();
	const [fetchProjects, setFetchProjects] = useState();
	const [timeEntryGuid, setTimeEntryGuid] = React.useState(null);
	const [fetchCustomers, setFetchCustomers] = useState(false);
	const [customerID, setCustomerID] = useState(null);

	const [fileName, setFileName] = useState("");
	const [tasks_list, setList] = useState([]);
	const [searchLoading, setSearchLoading] = useState(false);
	const [exportLoading, setExportLoading] = useState(false);
	const [clicked, setClicked] = React.useState(false);
	const [fetchEmployees, setFetchEmployees] = useState(false);
	const [employeeValue, setEmployeeValue] = useState([]);
	const [employeeIDs, setEmployeeIDs] = useState([]);
	const [projectIDs, setProjectIDs] = useState([]);

	const [editMode, setEditMode] = React.useState(false);
	const [timeEntry, setTimeEntry] = React.useState(null);
	const [fetchDimensions, setFetchDimensions] = useState(false);

	const [selectedDimensions, setSelectedDimensions] = useState({
		projectDimension1: null,
		projectDimension2: null,
	});

	const {
		data: projectDimensions,
		loading: projectDimensionsLoading,
		tokenChange: projectDimensionsWait,
	} = useQueryAuth(GET_ALL_PROJECT_DIMENSIONS, "GetAllProjectDimensions", {
		variables: {
			model: {
				userID: storeUserGuid,
			},
		},
		skip: !fetchDimensions,
		isWait: fetchDimensions,
	});
	useEffect(() => {
		if (columns.length === 0) {
			const actions = ({ compProps }) => {
				let props = compProps;
				return (
					<EditRecord
						{...props}
						handleClick={(v) => setClicked(v)}
						handleRowSelect={(t) => setTimeEntry(t)}
						handleEditMode={(v) => setEditMode(v)}
						disabled={manageTimeEntry !== "M"}
					/>
				);
			};
			const col = getTable(actions);

			if (col) {
				setColumns(col.columns);
			}
		}
	}, [columns.length]);

	const {
		data: employeeData,
		loading: employeeLoading,
		tokenChange: employeeWait,
	} = useQueryAuth(GET_ALL_EMPLOYEES_DROPDOWN, "GetCompanyUsersList", {
		variables: {
			model: {
				enableFilters: false,
				tenantID: storeUserTenant,
				userID: storeUserGuid,
				timeEntryDisabled: true,
				showAll: true,
				activeUsers: true,
			},
		},
		skip: !fetchEmployees,
		isWait: fetchEmployees,
	});

	const {
		data: customersData,
		loading: customerLoading,
		tokenChange: customerWait,
	} = useQueryAuth(GET_ALL_CUSTOMERS_DROPDOWN, "GetAllCustomers", {
		variables: {
			model: {
				enableFilters: false,
				userID: storeUserGuid,
			},
		},
		skip: !fetchCustomers,
		isWait: fetchCustomers,
	});
	const employeeList =
		employeeData?.GetCompanyUsersList?.usersList?.employees || [];
	const customerList = customersData?.GetAllCustomers?.customers || [];

	// const {
	//   data: tasksList,
	//   loading: taskLoading,
	//   tokenChange: tasksWait,
	// } = useQueryAuth(GET_ALL_TASKS_DROPDOWN, "GetTasks", {
	//   variables: {
	//     model: {
	//       tenantID: storeUserTenant,
	//       enableFilters: false,
	//       onGoingTasks: false,
	//       timeEntriesCreationAllowed: true,
	//     },
	//   },
	//   skip:!projectsValue || projectsValue.length!==1,
	//   isWait:!projectsValue || projectsValue.length!==1,
	// });

	const {
		mfunction: getTasks,
		loading: projectTaskLoading,
		tokenChange: projectTasksWait,
	} = useLazyQueryAuth(GET_TASKS_BY_PROJECT_DROPDOWN, "GetTasksByProject");
	useEffect(() => {
		if (fetchTasks) {
			getTasks(
				{
					variables: {
						model: {
							projectID:
								projectsValue?.length == 1
									? projectsValue[0].projectGuid
									: null,
							userID: storeUserGuid,
							activeTask: false,
							timeEntriesCreationAllowed: true,
						},
					},
				},
				(response) => {
					setList(response?.GetTasksByProject?.tasks || []);
				}
			);
		}
	}, [fetchTasks]);

	const {
		data: projectsData,
		mfunction: getProjects,
		loading: projectLoading,
		tokenChange: projectsWait,
	} = useLazyQueryAuth(GET_ALL_PROJECTS_DROPDOWN, "GetAllProjects");

	useEffect(() => {
		if (fetchProjects) {
			getProjects(
				{
					variables: {
						model: {
							enableFilters: false,
							tenantID: storeUserTenant,
							userID: storeUserGuid,
						},
					},
					skip: !fetchProjects,
					isWait: fetchProjects,
				},
				(response) => {
					setProjectsList(
						response?.GetAllProjects?.projectsList?.projectViews || []
					);
				}
			);
		}
	}, [fetchProjects]);

	const {
		mfunction: getAllTimeEntries,
		loading: dataLoading,
		refetch: refetchData,
	} = useLazyQueryAuth(GET_TIME_ENTRIES, "GetTimeEntries");
	const fetchTableData = useCallback(
		(filters) => {
			setSearchLoading(true);
			// const onlyBillable = includeOption?.id == 2;
			// const onlyNotBillable = includeOption?.id == 3;
			// const filter = {
			// 	project: projectIDs,
			// 	employee: employeeIDs,
			// 	task: taskIDs,
			// 	dateFrom: dateFrom ? new Date(dateFrom).toDateString() : null,
			// 	dateTo: dateTo ? new Date(dateTo).toDateString() : null,
			// 	canManageTimeEntries: true,
			// 	open: false,
			// 	billable: onlyBillable,
			// 	nonBillable: onlyNotBillable,
			// };

			getAllTimeEntries(
				{
					variables: {
						model: {
							enableFilters: true,

							userID: storeUserGuid,
							customerGuid: customerID?.customerGuid || null,
							projectDimension1: selectedDimensions.projectDimension1
								? selectedDimensions.projectDimension1.value
								: undefined,
							projectDimension2: selectedDimensions.projectDimension2
								? selectedDimensions.projectDimension2.value
								: undefined,

							filters: filters,
						},
					},
				},
				(response) => {
					setSearchLoading(false);
					console.log("response", response);
					setData(response.GetTimeEntries.timeEntriesList.timeEntries);
				}
			);
			setSearchLoading(false);
		},
		[customerID, selectedDimensions]
	);

	useEffect(() => {
		//  fetchTableData();
		setFileName(`report-${new Date(dateFrom)}-${new Date(dateTo)}`);
	}, [columns.length, re]);

	function disableDates(date) {
		const oneDayBefore = new Date(dateFrom);
		oneDayBefore.setDate(oneDayBefore?.getDate() - 1);
		return date < oneDayBefore;
	}

	const { mfunction: logsOutUser } = useMutationAuth(
		LOGOUT_USER,
		"LogoutUser"
	);
	const mapTimeEntriesToExcelModel = (timeEntries) => {
		return timeEntries.map((entry) => ({
			TaskTitle: entry.task?.title || null,
			ProjectTitle: entry.task?.ticket?.project?.title || null,
			TaskGuid: entry.task.taskGuid || null,
			TimeEntryGuid: entry.timeEntryGuid || null,

			ResourceName: `${entry.employee?.firstName || ""} ${
				entry.employee?.lastName || ""
			}`.trim(),
			Description: entry.description || null,
			Date: entry.startTime
				? new Date(entry.startTime).toLocaleDateString()
				: null,
			UnformattedDate: entry.startTime ? new Date(entry.startTime) : null,
			Duration: entry.duration || 0,
			Billable: entry.billable ?? null,
			IsEditable: entry.isEditable ?? null,
			EmployeeGuid: entry.employee?.employeeGuid || null,
		}));
	};

	async function exportTimeToExcel(model, withResource, token = null) {
		{
			let new_model = {
				withResource: withResource,
				TimeEntries: mapTimeEntriesToExcelModel(model),
				projectName: "",
				dateFrom: new Date(dateFrom).toDateString(),
				dateTo: new Date(dateTo).toDateString(),
			};
			axios.interceptors.response.use(
				(response) => {
					// Add caching headers to the response
					response.headers["Cache-Control"] =
						"no-cache, no-store, must-revalidate";
					response.headers["Pragma"] = "no-cache";
					response.headers["Expires"] = "0";
					return response;
				},
				(error) => {
					return Promise.reject(error);
				}
			);

			{
				await axios
					.post(
						backendURL + `/ExportExcel/exportTimeEntriesByProject`,
						new_model,
						{
							headers: {
								Authorization: "Bearer " + (token ? token : jwtToken),
							},
							responseType: "blob", // Important to handle binary data
						}
					)
					.then((response) => {
						const contentDisposition =
							response.headers["content-disposition"];
						let fileName = "timeEntriesReport" + Date.now() + ".xlsx"; // Default file name

						const fileType =
							"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
						const blob = new Blob([response.data], { type: fileType });

						FileSaver.saveAs(blob, fileName);
						setExportLoading(false);
						// setFetched(false);
						//  setLoading(false);
					})
					.catch((error) => {
						setExportLoading(false);
						const errorCode = error?.response?.status || "";
						if (errorCode === 401) {
							//if Unauthorized, we logout the user
							logsOutUser(
								{
									variables: {
										model: {
											jwtToken: jwtToken,
										},
									},
								},
								() => {
									logout();
								}
							);
						} else if (errorCode === 400) {
							const desc = error?.response?.data || {};

							if (desc.error?.error === "IXIA_ACTIV_NEW_TOKEN") {
								updateToken(desc.error.errorVariable.trim());
								exportTimeToExcel(desc.error.errorVariable.trim());
							} else if (
								desc.error?.error !== "IXIA_ACTIV_UNAUTHORIZED"
							) {
								enqueueSnackbar(
									t(error?.response?.data?.message || ""),
									{
										variant: "error",
										autoHideDuration: 5000,
									}
								);
							}
						} else {
							enqueueSnackbar(t(error?.response?.data?.message || ""), {
								variant: "error",
								autoHideDuration: 5000,
							});
						}
						//  setLoading(false);
					});
			}
		}
	}

	async function exportTaskToExcel(model, token = null) {
		{
			let new_model = {
				withResource: false,
				TimeEntries: mapTimeEntriesToExcelModel(model),
				projectName: "",
				dateFrom: new Date(dateFrom).toDateString(),
				dateTo: new Date(dateTo).toDateString(),
			};
			axios.interceptors.response.use(
				(response) => {
					// Add caching headers to the response
					response.headers["Cache-Control"] =
						"no-cache, no-store, must-revalidate";
					response.headers["Pragma"] = "no-cache";
					response.headers["Expires"] = "0";
					return response;
				},
				(error) => {
					return Promise.reject(error);
				}
			);

			{
				await axios
					.post(
						backendURL + `/ExportExcel/exportTasksByProject`,
						new_model,
						{
							headers: {
								Authorization: "Bearer " + (token ? token : jwtToken),
							},
							responseType: "blob", // Important to handle binary data
						}
					)
					.then((response) => {
						const contentDisposition =
							response.headers["content-disposition"];
						let fileName = "timeEntriesReport" + Date.now() + ".xlsx"; // Default file name

						const fileType =
							"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
						const blob = new Blob([response.data], { type: fileType });

						FileSaver.saveAs(blob, fileName);

						setExportLoading(false);
					})
					.catch((error) => {
						setExportLoading(false);
						const errorCode = error?.response?.status || "";
						if (errorCode === 401) {
							//if Unauthorized, we logout the user
							logsOutUser(
								{
									variables: {
										model: {
											jwtToken: jwtToken,
										},
									},
								},
								() => {
									logout();
								}
							);
						} else if (errorCode === 400) {
							const desc = error?.response?.data || {};

							if (desc.error?.error === "IXIA_ACTIV_NEW_TOKEN") {
								updateToken(desc.error.errorVariable.trim());
								exportTimeToExcel(desc.error.errorVariable.trim());
							} else if (
								desc.error?.error !== "IXIA_ACTIV_UNAUTHORIZED"
							) {
								enqueueSnackbar(
									t(error?.response?.data?.message || ""),
									{
										variant: "error",
										autoHideDuration: 5000,
									}
								);
							}
						} else {
							enqueueSnackbar(t(error?.response?.data?.message || ""), {
								variant: "error",
								autoHideDuration: 5000,
							});
						}
						//  setLoading(false);
					});
			}
		}
	}
	const handleExport = () => {
		if (data != [] && data != null && data.length > 0) {
			// exportTaskToExcel()
			setExportLoading(true);
			exportOption?.id == 1
				? exportTimeToExcel(data, false)
				: exportOption?.id == 2
				? exportTaskToExcel(data)
				: exportTimeToExcel(data, true);
		}
		handleClose();
	};
	const pagination = {
		rows: data,
		columns,
		numberRecords: numOfRecords,
		fetchTableData,
		loading: dataLoading,
		hideEditColumns: true,
		removeFilters: true,
		removeSelectAll: true,
		hideSearchBar: true,
		removeRefresh: true,
		removePagination: true,
		removeSorting: true,
	};

	const handleClose = () => {
		setFileName("");
		setIncludeSubtasks(false);
		setOpenDialog(false);
	};

	const handleSave = () => {
		exportToExcel(data, fileName);
		handleClose();
	};

	return (
		<>
			<TimeEntryDrawer
				PaperComponent={PaperComponent}
				openTimeEntryModal={clicked}
				setOpenTimeEntryModal={(v) => setClicked(setClicked)}
				timeSheetGuid={null}
				timeEntryGuid={timeEntry?.timeEntryGuid}
				description={timeEntry?.description}
				synced={false}
				refetchData={refetchData}
				refetchTasks={null}
				editMode={true}
				handleEditMode={(v) => setEditMode(v)}
				handleChangeTimeEntryGuid={(v) => setTimeEntryGuid(v)}
				//employees={employeesList}
				resetFields={null}
				selectedTask={null}
				t={t}
			/>
			<FieldModal
				PaperComponent={PaperComponent}
				CustomButton={CustomButton}
				// content={t("dialog.file.name")}
				loading={false}
				openDialog={openDialog}
				handleClose={handleClose}
				handleSave={handleSave}
				setState={(v) => setFileName(v)}
				title={t("dialog.file.name")}
				label={t("task.list.exportToExcel.fileName")}
				t={t}
			/>
			<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
				<ContainerCard
					className="projects-card"
					sx={{
						width: "100%",
						padding: "10px",
						display: "grid",
						gridTemplateColumn: "1fr",
						backgroundColor: "transparent !important",
						boxShadow: "none !important",
						gap: "20px",
					}}
				>
					<Grid container spacing={1}>
						<Grid
							item
							xs={12}
							sm={5}
							md={4}
							lg={3}
							xl={3}
							sx={{ marginBottom: "10px !important" }}
						>
							<AutoComplete
								multiple
								disableCloseOnSelect
								loading={employeeLoading}
								options={employeeList}
								getOptionLabel={(option) =>
									option
										? option.firstName + " " + option.lastName
										: ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.firstName + " " + option.lastName}
									</li>
								)}
								identifier={"employeeGuid"}
								size="small"
								value={employeeValue}
								onOpen={() => setFetchEmployees(true)}
								onClose={() => setFetchEmployees(false)}
								onChange={(event, value) => {
									setEmployeeValue(value);
									let tmp = [];
									value.map((ids, inxex) => {
										tmp.push(ids.employeeGuid);
									});
									setEmployeeIDs(tmp);
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
									"& .MuiChip-root": {
										marginLeft: "15px !important",
									},
								}}
								roundedTextField
								label={t("reports.label.employee")}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
							<AutoComplete
								multiple
								disableCloseOnSelect
								loading={projectLoading}
								options={projectsList}
								getOptionLabel={(option) =>
									option ? option.title : ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.title}
									</li>
								)}
								identifier={"projectGuid"}
								size="small"
								value={projectsValue}
								onOpen={() => setFetchProjects(true)}
								onClose={() => setFetchProjects(false)}
								onChange={(event, value) => {
									setProjectsValue(value);
									let tmp = [];
									value.map((ids, inxex) => {
										tmp.push(ids.projectGuid);
										return tmp;
									});
									setProjectIDs(tmp);
									setFetchTasks(false);
									setTaskValue([]);
									setTaskIDs([]);
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
									"& .MuiChip-root": {
										marginLeft: "15px !important",
									},
								}}
								roundedTextField
								label={t("reports.label.project")}
							/>
						</Grid>

						<Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
							<AutoComplete
								multiple
								disableCloseOnSelect
								//   loading={taskLoading}
								options={tasks_list || []}
								getOptionLabel={(option) =>
									option ? option.title : ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.title}
									</li>
								)}
								identifier={"taskGuid"}
								size="small"
								value={taskValue}
								onOpen={() =>
									projectsValue && projectsValue?.length === 1
										? setFetchTasks(true)
										: {}
								}
								onClose={() => setFetchTasks(false)}
								onChange={(event, value) => {
									setTaskValue(value);
									let tmp = [];
									value.map((ids, inxex) => {
										tmp.push(ids.taskGuid);
									});
									setTaskIDs(tmp);
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
									"& .MuiChip-root": {
										marginLeft: "15px !important",
									},
								}}
								roundedTextField
								label={t("reports.label.tasks")}
								disabled={!projectsValue || projectsValue?.length !== 1}
							/>
						</Grid>

						<Grid
							item
							xs={12}
							sm={6}
							md={3}
							lg={3}
							xl={3}
							sx={{ marginBottom: "10px !important" }}
						>
							<AutoComplete
								multiple={false}
								loading={customerLoading}
								options={customerList}
								getOptionLabel={(option) => (option ? option.name : "")}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.name}
									</li>
								)}
								identifier={"customerGuid"}
								size="small"
								value={customerID}
								onOpen={() => setFetchCustomers(true)}
								onClose={() => setFetchCustomers(false)}
								onChange={(event, value) => {
									setCustomerID(value);
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
								}}
								label={t("reports.label.customer")}
								roundedTextField
							/>
						</Grid>
						<Grid
							item
							xs={12}
							sm={6}
							md={3}
							lg={3}
							xl={3}
							sx={{ marginBottom: "10px !important" }}
						>
							<AutoComplete
								multiple={false}
								loading={projectDimensionsLoading}
								options={
									projectDimensions?.GetAllProjectDimensions?.projectDimension1?.map(
										(dimension) => ({
											name: dimension,
											value: dimension,
										})
									) || []
								}
								getOptionLabel={(option) => (option ? option.name : "")}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.name}
									</li>
								)}
								identifier={"projectDimension1"}
								size="small"
								value={selectedDimensions.projectDimension1}
								onOpen={() => setFetchDimensions(true)}
								onClose={() => setFetchDimensions(false)}
								onChange={(event, value) => {
									setSelectedDimensions((prev) => ({
										...prev,
										projectDimension1: value,
									}));
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
								}}
								label={projectDimension1Label}
								roundedTextField
							/>
						</Grid>
						<Grid
							item
							xs={12}
							sm={6}
							md={3}
							lg={3}
							xl={3}
							sx={{ marginBottom: "10px !important" }}
						>
							<AutoComplete
								multiple={false}
								loading={projectDimensionsLoading}
								options={
									projectDimensions?.GetAllProjectDimensions?.projectDimension2?.map(
										(dimension) => ({
											name: dimension,
											value: dimension,
										})
									) || []
								}
								getOptionLabel={(option) => (option ? option.name : "")}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.name}
									</li>
								)}
								identifier={"projectDimension2"}
								size="small"
								value={selectedDimensions.projectDimension2}
								onOpen={() => setFetchDimensions(true)}
								onClose={() => setFetchDimensions(false)}
								onChange={(event, value) => {
									setSelectedDimensions((prev) => ({
										...prev,
										projectDimension2: value,
									}));
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
								}}
								label={projectDimension2Label}
								roundedTextField
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={2} lg={2} xl={2} mt={1}>
							<RoundedDatePicker
								className="date_picker_styles"
								label={t("projectDashboard.label.DateFrom")}
								value={dateFrom}
								disableFuture
								onChange={(newValue) => {
									setDateFrom(newValue);
									setDateVal(
										data_filter.find((x) => x.mnemonic === "custom")
									);
								}}
								onClose={() => setOpen(true)}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={2} lg={2} xl={2} mt={1}>
							<RoundedDatePicker
								className="date_picker_styles"
								label={t("projectDashboard.label.DateTo")}
								value={dateTo}
								shouldDisableDate={disableDates}
								autoFocus={open}
								open={open}
								onClose={() => setOpen(false)}
								onClick={() => setOpen(!open)}
								onOpen={() => setOpen(!open)}
								onChange={(newValue) => {
									handleValidateDates(
										timer,
										setTimer,
										dateFrom,
										newValue,
										setDateTo,
										enqueueSnackbar,
										t
									);
									setDateVal(
										data_filter.find((x) => x.mnemonic === "custom")
									);
								}}
							/>
						</Grid>
						<Tooltip title={t("tooltip.PreviousPeriod")}>
							<Grid
								item
								sx={{ display: "flex", alignItems: "center" }}
								mt={1}
							>
								<PreviousIcon
									color={
										dateVal.mnemonic === "custom"
											? "#73717380"
											: "#737173"
									}
									onClick={() => {
										if (dateVal.mnemonic !== "custom")
											handleDateBackward(
												dateFrom,
												dateTo,
												dateVal,
												setDateFrom,
												setDateTo
											);
									}}
								/>
							</Grid>
						</Tooltip>
						<Grid item xs={12} sm={4} md={1.5} lg={1.5} xl={1.5} mt={1}>
							<Autocomplete
								options={data_filter}
								getOptionLabel={(option) =>
									option ? t(option.name) : ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.name}
									</li>
								)}
								isOptionEqualToValue={(option, value) =>
									value == "" || option.mnemonic === value.mnemonic
								}
								size="small"
								disableClearable
								value={dateVal}
								onChange={(event, value) => {
									setDateVal(value);
									handleTimeBetween(
										value.mnemonic,
										setDateFrom,
										setDateTo
									);
								}}
								fullWidth
								PaperComponent={(props) => (
									<AutoCompletePaper {...props} />
								)}
								renderInput={(params) => (
									<RoundedTextField
										label={t("dateFilter.label")}
										size="small"
										removeMinWidth
										{...params}
									/>
								)}
								sx={{
									".MuiInputBase-input": {
										fontSize: "14px !important",
									},
								}}
							/>
						</Grid>
						<Tooltip title={t("tooltip.NextPeriod")}>
							<Grid
								item
								sx={{ display: "flex", alignItems: "center" }}
								mt={1}
							>
								<NextIcon
									color={
										dateVal.mnemonic === "custom"
											? "#73717380"
											: "#737173"
									}
									onClick={() => {
										if (dateVal.mnemonic !== "custom")
											handleDateForward(
												dateFrom,
												dateTo,
												dateVal,
												setDateFrom,
												setDateTo
											);
									}}
								/>
							</Grid>
						</Tooltip>
						<Grid
							item
							xs={12}
							sm={6}
							md={3}
							lg={3}
							xl={3}
							style={{
								paddingTop: "15px",
							}}
						>
							<AutoComplete
								options={exportOptions}
								getOptionLabel={(option) =>
									option ? option.title : ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.title}
									</li>
								)}
								identifier={"id"}
								size="small"
								value={exportOption}
								onOpen={() => setFetchProjects(true)}
								onClose={() => setFetchProjects(false)}
								required
								onChange={(event, value) => {
									setExportOption(value);
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
									"& .MuiChip-root": {
										marginLeft: "15px !important",
									},
								}}
								roundedTextField
								label={t("reports.label.exportOption")}
							/>
						</Grid>
						<Grid
							item
							xs={12}
							sm={6}
							md={3}
							lg={3}
							xl={3}
							style={{
								paddingTop: "15px",
							}}
						>
							<AutoComplete
								options={includeOptions}
								getOptionLabel={(option) =>
									option ? option.title : ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.title}
									</li>
								)}
								identifier={"id"}
								size="small"
								value={includeOption}
								required
								onChange={(event, value) => {
									setIncludeOption(value);
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
									"& .MuiChip-root": {
										marginLeft: "15px !important",
									},
								}}
								roundedTextField
								label={t("reports.label.includeOption")}
							/>
						</Grid>

						{/* <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              xl={3}
              sx={{ margin: { sm: "10px !important" } }}
            >
              <FormGroup
                sx={{
                  ".MuiTypography-root": {
                    fontSize: "14px !important",
                  },
                  "& .MuiSvgIcon-root": { fontSize: 16 },
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={includeSubtasks}
                      onChange={(e) => setIncludeSubtasks(e.target.checked)}
                    />
                  }
                  label={t("taskModal.includeSubtasks")}
                />
              </FormGroup>
            </Grid> */}
						<Grid
							item
							xs={12}
							sm={12}
							md={12}
							lg={12}
							xl={12}
							sx={{ display: "flex", justifyContent: "flex-start" }}
						>
							<IALoadingButton
								onClick={() =>
									fetchTableData({
										project: projectIDs,
										employee: employeeIDs,
										task: taskIDs,
										dateFrom: dateFrom
											? new Date(dateFrom).toDateString()
											: null,
										dateTo: dateTo
											? new Date(dateTo).toDateString()
											: null,
										canManageTimeEntries: true,
										open: false,

										billable: includeOption?.id == 2,
										nonBillable: includeOption?.id == 3,
									})
								}
								style={{
									width: "fit-content",
									backgroundColor: dark_logo_blue,
									borderRadius: "50px",
									height: "36px",
								}}
								loading={searchLoading}
								label={t("projectDashboard.Search")}
								tooltipLabel={t("reports.tooltip.project.search")}
								disabled={
									(projectIDs.length < 1 && employeeIDs.length < 1) ||
									exportLoading ||
									searchLoading
								}
							/>
							<IALoadingButton
								disabled={
									!data ||
									data?.length < 1 ||
									exportLoading ||
									searchLoading
								}
								onClick={() => {
									// if (data?.length > 0) exportToExcel(data, fileName);
									if (data?.length > 0) handleExport();
								}}
								style={{
									width: "fit-content",
									backgroundColor: "#107C41",
									borderRadius: "50px",
									height: "36px",
									marginLeft: "10px",
								}}
								//disabled={searchLoading || data.length<1}
								loading={exportLoading}
								label={t("report.exportToExcel")}
								tooltipLabel={t("reports.tooltip.excel.search")}
							/>
							{/* <IALoadingButton
          onClick={() => handleExport()}
          style={{
            width: "fit-content",
            backgroundColor: dark_logo_blue,
            borderRadius: "50px",
            height: "36px",
          }}
          label={t("task.list.exportToExcel")}
        /> */}
						</Grid>
					</Grid>
					{dataLoading && columns.length === 0 ? (
						<ContainerCard
							sx={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								padding: "20px",
							}}
						>
							<CircularProgress />
						</ContainerCard>
					) : (
						<DataTable
							{...pagination}
							fixedWidth={"calc(100vw - 340px)"}
							height={"calc(100vh - 380px)"}
						/>
					)}
				</ContainerCard>
			</Grid>
		</>
	);
}

export default ExcelReport;
